/**
 *  Module for localization
 */

const Localization = function(app) {

  /**
   *  Private Properties/Methods
   */
  let configure3Settings = null,
    configure3LocalizationKeys = null;
  const configure = app.configure;

  window.updateAppText = {};

  /**
  Convert a string that was underscored to camel-cased. Good for
  localization keys that are typically set in underscored.

  @method camelize
  @returns {String} Camel case version of argument
  **/
  function camelize(s) {
    const camelized = s.replace(/(?:^|[-_])(\w)/g, function(_, c) {
      return c ? c.toUpperCase() : '';
    });
    return camelized[0].toLowerCase() + camelized.slice(1);
  }

  /**
   * Read all of the standard components' localization keys, which
   * in 3.0 are stored in a different place from custom components.
   * But in 2.0, the labels are listed in the admin tools.
   * So this will create 2.0-like labels, albeit camel-cased:
   * shareButtonLabel, shareButtonTooltip
   *
   */
  function getConfigure2LocalizationKeys(configure3Settings) {
    const fc2Labels = {};
    for (const componentName in configure3Settings) {
      if (configure3Settings.hasOwnProperty(componentName)) {
        const component = configure3Settings[componentName];
        for (const key in component.i18n) {
          if (component.i18n.hasOwnProperty(key)) {
            const label = component.i18n[key];
            fc2Labels[camelize(componentName + '_' + key)] = label;
          }
        }
      }
    }
    return fc2Labels;
  }

  function replaceText(string, options) {
    for (const option in options) {
      if (options.hasOwnProperty(option)) {
        string = string.replace('{' + option + '}', options[option]);
      }
    }

    return string;
  }

  /**
  Get the correct translated text for the current locale

  @method getLang
  @param {String} key The key from the locale JSON you want to grab
  @return {String} Returns the value of the passed key
  **/
  function getLang(key, _default, replacements) {
    if (typeof configure3Settings.globals.i18n[camelize(key)] !== 'undefined') {
      return replaceText(configure3Settings.globals.i18n[camelize(key)], replacements);
    } else if (typeof configure3LocalizationKeys[camelize(key)] !== 'undefined') {
      return replaceText(configure3LocalizationKeys[camelize(key)], replacements);
    } else {
      if (app.mergedParams.workflow !== 'prod' && !window.updateAppText.hasOwnProperty(key)) {
        window.updateAppText[key] = _default;
        console.warn(`Need to update Application Text with ${key} - Currently using "${_default}"`, window.updateAppText);
      }
      return replaceText(_default, replacements);
    }
  }

  function init() {
    // Retrieve Configure 3 variables that will get used later
    configure3Settings = configure.run('getUiSettings');
    configure3LocalizationKeys = getConfigure2LocalizationKeys(configure3Settings);
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    init,
    getLang
  };
};

module.exports = Localization;
